export function formatNumber(num) {
    if (num == null || num === '') return '0';
    const n = Number(num);
    if (!Number.isFinite(n)) return '0';
    return Math.trunc(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}
